export enum CalculatorMode {
  GENERIC_EVENT = "GENERIC_EVENT",
  BUSINESS = "BUSINESS"
}
